import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  OneToMany,
  PrimaryGeneratedColumn,
  Entity,
  ManyToOne
} from 'typeorm';
import PrecoPromocional from './PrecoPromocional';
import Cardapio from './Cardapio';

@Entity()
export class Promocao {
  @PrimaryGeneratedColumn()
  id!: number;

  @ManyToOne(() => Cardapio, { eager: true })
  cardapio!: Cardapio;

  @Column()
  nome: string = '';

  @Column()
  ativo: boolean = true;

  @Column()
  descricao: string = '';

  @Column()
  urlBanner: string = '';

  @OneToMany(() => PrecoPromocional, (produto: PrecoPromocional) => produto.promocao, {
    cascade: true
  })
  precosPromocionais!: PrecoPromocional[];

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export default Promocao;
